"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StringSeparator_1 = require("../../enums/StringSeparator");
exports.InputFileNameRule = (options) => {
    let { inputFileName } = options;
    if (inputFileName) {
        inputFileName = inputFileName
            .replace(/^\/+/, '')
            .split(StringSeparator_1.StringSeparator.Dot)
            .slice(0, -1)
            .join(StringSeparator_1.StringSeparator.Dot) || inputFileName;
        options = Object.assign(Object.assign({}, options), { inputFileName: `${inputFileName}.js` });
    }
    return options;
};
